import type { FC } from 'react'
import React from 'react'
import { v4 as uuid } from 'uuid'

import { CollapsibleContainer, CollapsibleContainerBody, CollapsibleContainerHeader } from '@vfuk/core-collapsible-container'
import Link from '@vfuk/core-link'
import Divider from '@vfuk/core-divider'
import ListItem from '@vfuk/core-list-item'
import { getDataSelector } from '@vfuk/core-base-props'

import * as Styled from './styles/MobileLinkList.style'

import type { MobileLinkListProps } from './MobileLinkList.types'

const MobileLinkList: FC<MobileLinkListProps> = ({ linkGroups, onInteractionClick, appearance, footerTheme, dataSelectorPrefix }) => {
  const { collapsibleContainerAppearance, inverseCollapsibleContainer, inverseText, dividerAppearance, inverseDivider } =
    footerTheme.appearance[appearance!]

  return (
    <Styled.MobileLinkListWrapper data-selector={getDataSelector(dataSelectorPrefix)}>
      {linkGroups!.groups.map((group, index) => (
        <React.Fragment key={uuid()}>
          <CollapsibleContainer
            appearance={collapsibleContainerAppearance}
            inverse={inverseCollapsibleContainer}
            isActive={linkGroups!.openOnMD}
            dataSelectorPrefix={getDataSelector(dataSelectorPrefix, `group-${index}`)}
          >
            <CollapsibleContainerHeader dataSelectorPrefix={getDataSelector(dataSelectorPrefix, `group-header-${index}`)}>
              {group.headingText}
            </CollapsibleContainerHeader>
            <CollapsibleContainerBody key={uuid()} dataSelectorPrefix={getDataSelector(dataSelectorPrefix, `group-body-${index}`)}>
              <Styled.LinkListWrapper>
                {group.links.map((link) => (
                  <ListItem key={link.id} dataSelectorPrefix={getDataSelector(dataSelectorPrefix, `item-${index}`)}>
                    <Link
                      inverse={inverseText}
                      srText={link.srText}
                      href={link.href}
                      customRouterProps={link.customRouterProps}
                      onClick={onInteractionClick}
                      dataSelectorPrefix={getDataSelector(dataSelectorPrefix, `item-link-${index}`)}
                      {...link.dataAttributes}
                    >
                      {link.text}
                    </Link>
                  </ListItem>
                ))}
              </Styled.LinkListWrapper>
            </CollapsibleContainerBody>
          </CollapsibleContainer>
          {index !== linkGroups!.groups.length - 1 && <Divider appearance={dividerAppearance} inverse={inverseDivider} />}
        </React.Fragment>
      ))}
    </Styled.MobileLinkListWrapper>
  )
}

export default MobileLinkList
